function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export var ShakaManifestPreprocessor = /*#__PURE__*/ function() {
    "use strict";
    function ShakaManifestPreprocessor(errorHandler) {
        _class_call_check(this, ShakaManifestPreprocessor);
        _define_property(this, "errorHandler", void 0);
        _define_property(this, "processors", void 0);
        this.errorHandler = errorHandler;
        this.processors = [];
    }
    _create_class(ShakaManifestPreprocessor, [
        {
            key: "addProcessor",
            value: function addProcessor(handler) {
                this.processors.push(handler);
            }
        },
        {
            key: "cleanup",
            value: function cleanup() {
                this.processors = [];
            }
        },
        {
            key: "process",
            value: function process(manifest) {
                var _this = this;
                this.processors.forEach(function(processor) {
                    try {
                        processor.callback(manifest);
                    } catch (e) {
                        _this.errorHandler(processor, e);
                    }
                });
            }
        }
    ]);
    return ShakaManifestPreprocessor;
}();

//# sourceMappingURL=shaka-manifest-preprocessor.js.map